"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateSendUtxoOperation = exports.estimateSendOperation = exports.estimateBaseTransaction = void 0;
const transaction_1 = require("../../transaction");
const operation_1 = require("../operation");
const fee_1 = require("./fee");
const transaction_2 = require("./transaction");
async function getBaseTxFee(provider, type, chain) {
    return new fee_1.BaseFeeData(chain, BigInt((await provider.info.getTxFee()).txFee), type);
}
async function estimateBaseTransaction(provider, chain, utxoSet, signersAddresses, changeAddress, assetId, amount, addresses, threshold, locktime, stakeable) {
    const fee = await getBaseTxFee(provider, transaction_2.TransactionType.Base, chain);
    const transaction = chain.id === provider.platformChain.id
        ? (0, transaction_1.buildPlatformBaseTransaction)([new transaction_1.UserInput(assetId, chain, amount, addresses, threshold, chain, locktime, stakeable)], utxoSet, signersAddresses, fee.amount, changeAddress, provider.mcn.id)
        : (0, transaction_1.buildJVMBaseTransaction)([new transaction_1.UserInput(assetId, chain, amount, addresses, threshold, chain, locktime)], utxoSet, signersAddresses, fee.amount, changeAddress, provider.mcn.id);
    return new fee_1.UtxoFeeData(fee.chain, fee.amount, fee.type, transaction);
}
exports.estimateBaseTransaction = estimateBaseTransaction;
async function estimateSendOperation(provider, chain, account, send) {
    const values = new Map([[send.assetId, send.amount]]);
    return await estimateBaseTransaction(provider, chain, account.utxoSet, transaction_1.Address.toAddresses(account.getSignersAddresses()), account.address, send.assetId, send.amount, [send.address], 1, BigInt(0), false).then((fee) => {
        const spending = new transaction_2.UtxoSpending(chain, send.amount, send.assetId, fee.transaction.getUtxos());
        return new operation_1.ChainOperationSummary(provider, send, chain, fee, [spending, fee.spending], values);
    }, async () => {
        const fee = await getBaseTxFee(provider, transaction_2.TransactionType.Base, chain);
        return new operation_1.ChainOperationSummary(provider, send, chain, fee, [new transaction_2.BaseSpending(chain, send.amount, send.assetId), fee.spending], values);
    });
}
exports.estimateSendOperation = estimateSendOperation;
async function estimateSendUtxoOperation(provider, chain, account, send) {
    const values = new Map([[send.assetId, send.amount]]);
    const fee = await getBaseTxFee(provider, transaction_2.TransactionType.Base, chain);
    // do not add a spending if utxoSet is defined as this means it is a multiSig op
    const hasSpending = typeof send.utxoSet === 'undefined';
    return await estimateBaseTransaction(provider, chain, send.getPreferredUtxoSet(account, fee.amount), send.getPreferredSigners(account), account.address, send.assetId, send.amount, send.addresses, send.threshold, send.locktime, send.stakeable).then((fee) => {
        const spendings = [fee.spending];
        if (hasSpending) {
            spendings.unshift(new transaction_2.UtxoSpending(chain, send.amount, send.assetId, fee.transaction.getUtxos()));
        }
        return new operation_1.ChainOperationSummary(provider, send, chain, fee, spendings, values);
    }, async () => {
        const spendings = [fee.spending];
        if (hasSpending) {
            spendings.unshift(new transaction_2.BaseSpending(chain, send.amount, send.assetId));
        }
        return new operation_1.ChainOperationSummary(provider, send, chain, fee, spendings, values);
    });
}
exports.estimateSendUtxoOperation = estimateSendUtxoOperation;
